import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function WarningDialog({ setIsWarningDialog, isWarningDialog }) {
  const handleClose = () => {
    setIsWarningDialog(false);
  };

  return (
    <Dialog open={isWarningDialog} onClose={handleClose}>
      <DialogTitle style={{ backgroundColor: "yellow" }}>Warning!</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: "Black" }}>
          Please edit the video.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>ok</Button>
      </DialogActions>
    </Dialog>
  );
}
